export default {
  maxCharacters: 1000 * 100,
};
